import SEOArticleLayout from "@/components/feature/SEOArticleLayout";
import { categoryDeepDive } from "@/mocks/articles";

export default function CategoryDeepDive() {
  return (
    <SEOArticleLayout
      slug={categoryDeepDive.slug}
      title={categoryDeepDive.title}
      metaDescription={categoryDeepDive.metaDescription}
      publishDate={categoryDeepDive.publishDate}
      readTime={categoryDeepDive.readTime}
      badge={categoryDeepDive.badge}
      heroImage={categoryDeepDive.heroImage}
      sections={categoryDeepDive.sections}
      relatedArticles={[
        { label: "Complete Guide", to: "/hipobuy-spreadsheet-complete-guide" },
        { label: "vs Kakobuy", to: "/hipobuy-spreadsheet-vs-kakobuy" },
        { label: "vs CSSBuy", to: "/hipobuy-spreadsheet-vs-cssbuy" },
        { label: "vs Superbuy", to: "/hipobuy-spreadsheet-vs-superbuy" },
        { label: "vs Oopbuy", to: "/hipobuy-spreadsheet-vs-oopbuy" },
      ]}
    />
  );
}